import React, { useState, useEffect } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { createPortal } from 'react-dom';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { codeSnippets } from '../Data/Snippets';
import '../Styles/CodeGallery.css';

export function CodeGallery() {
	const [activeSnippet, setActiveSnippet] = useState(null);
	const [allCode, setAllCode] = useState({});
	
	useEffect(() => {
		let isMounted = true;

		const loadFilesSequentially = () => {
			codeSnippets.forEach(async (snippet) => {
				try {
					const res = await fetch(`${process.env.PUBLIC_URL}/Snippets/${snippet.file}`);
					if (!res.ok) throw new Error("Not found");
					const text = await res.text();

					if (isMounted) {
						setAllCode(prev => ({
							...prev,
							[snippet.id]: text
						}));
					}
				} catch (err) {
					if (isMounted) {
						setAllCode(prev => ({
							...prev,
							[snippet.id]: "// Error loading source file."
						}));
					}
				}
			});
		};

		loadFilesSequentially();
		return () => { isMounted = false; };
	}, []);

	return (
		<>
			<div className="code-gallery-container">
				<div className="code-grid">
					{codeSnippets.map((item) => (
						<div key={item.id} className="code-card" onClick={() => setActiveSnippet(item)}>
							<div className="code-card-header">
								<span className="code-title">{item.title}</span>
								<div className="win-controls">
									<span className="win-icon">─</span>
									<span className="win-icon">▢</span>
									<span className="win-icon close">✕</span>
								</div>
							</div>
							<div className="code-preview no-select">
								<div className="no-copy-overlay"></div>
								<SyntaxHighlighter
									language={item.language}
									style={vscDarkPlus}
									customStyle={{ margin: 0, padding: '15px', background: 'transparent', overflow: 'hidden' }}
								>
									{allCode[item.id]
										? allCode[item.id].split('\n').slice(0, 9).join('\n') + "\n..."
										: "Loading preview..."}
								</SyntaxHighlighter>
							</div>
						</div>
					))}
				</div>

				{activeSnippet && createPortal (
					<div className="code-modal-overlay" onClick={() => setActiveSnippet(null)}>
						<div className="code-modal-content" onClick={e => e.stopPropagation()}>
							<div className="code-modal-header">
								<span className="code-title">{activeSnippet.title}</span>
								<div className="win-controls">
									<span className="win-icon" onClick={() => setActiveSnippet(null)}>─</span>
									<span className="win-icon" onClick={() => setActiveSnippet(null)}>▢</span>
									<span className="win-icon close" onClick={() => setActiveSnippet(null)}>✕</span>
								</div>
							</div>

							<div className="code-description-bar">
								<div className="description-content" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
									<p style={{ margin: 0 }}>{activeSnippet.description}</p>
									
									{activeSnippet.repoUrl && (
										<a 
											href={activeSnippet.repoUrl} 
											target="_blank" 
											rel="noopener noreferrer" 
											className="repo-button"
										>
											View Repository
										</a>
									)}
								</div>
							</div>

							<div className="code-full-view no-select">
								<SyntaxHighlighter 
									language={activeSnippet.language} 
									style={vscDarkPlus}
									showLineNumbers={true}
									customStyle={{ margin: 0, background: '#1e1e1e' }}
								>
									{allCode[activeSnippet.id] || "Loading..."}
								</SyntaxHighlighter>
							</div>
							
						</div>
					</div>,
					document.body
				)}
			</div>
		</>
	);
}